<template>
  <router-view v-wechat-title="$route.meta.title" />
</template>
<script>
import { getWxConfig } from "./api/examination(22524)";
import { getCurrentInstance } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    // 获取js-api配置信息
    const getWxConfigFun = async () => {
      const instance = getCurrentInstance();
      const res = await getWxConfig({ url: window.location.href });
      if (res.code == 200) {
        let data = res.data;
        store.commit("setAppid", data.appId);
        instance.appContext.config.globalProperties.$wx.config({
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "getLocation",
            "chooseWXPay",
            "onMenuShareAppMessage",
          ], // 必填，需要使用的JS接口列表
        });
      }
    };
    getWxConfigFun();
  },
};
</script>
<style lang="scss">
body,
html,
div,
span,
img {
  padding: 0;
  margin: 0;
  border: none;
}
div::-webkit-scrollbar {
  width: 0 !important;
}
</style>
